import { lang } from '@lang';
import { Trash2 } from 'lucide-react';
import { useDesign } from '@hooks';

import { Feature } from '..';
import { selectRemovedAccessory, setRemovedAccessory, useAppDispatch, useAppSelector } from '@state';

export const useRemoveAccessoryFeature = (): Feature<string> => {
	const [controller] = useDesign();
	const dispatch = useAppDispatch();

	const kitchen = controller?.kitchen ?? null;
	const removeAccessory = useAppSelector(selectRemovedAccessory);

	return {
		name: 'remove-accessory',
		label: lang.accessories.label.delete,
		shortcut: '',
		tooltip: lang.accessories.tooltip.deleteSku,
		icon: (props = {}) => <Trash2 {...props} />,
		disabled: false,
		value: '',
		hidden: false,
		handler: () => {
			kitchen?.accessories.children.forEach((sku, index) => {
				if (sku.sku === removeAccessory) {
					kitchen?.accessories.children.splice(index, 1);
				}
			});

			dispatch(setRemovedAccessory(''));
		}
	};
};
